import api from '../api'

export default {
  
  orders: async (page, take, sortBy, sortOrder, search) => {
    return api.get(`api/orders?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}`)
  },

  get: async id => {
    return api.get('api/orders/' + id)
  },

  sendToSage: async id => {
    return api.get('api/shopify/order-to-sage/' + id)
  },

  fetchShopify: async number => {
    return api.get('api/shopify/order-fetch/' + number)
  },

}
